import { ArrowTrendingDownIcon, ArrowTrendingUpIcon } from '@heroicons/react/24/solid'
import classNames from 'classnames'
import { useMemo } from 'react'
import { chipBase, hueClasses } from 'app/lib/chipColors'
import { debug } from 'lib/logging'

export default function TrendLabel({ previous, current }) {
  const variation = useMemo(() => current - previous, [previous, current])
  debug(`stats`, `trend label`, variation, previous)
  let val: number | null = Math.round((variation / previous) * 100)
  if (val === Infinity || isNaN(val)) val = null
  if (current === 0 && previous === 0) val = 0
  return (
    <>
      {!!val && (
        <div className={classNames(chipBase, variation >= 0 ? hueClasses.green : hueClasses.red)}>
          <span>{`${Math.abs(val)}%`}</span>
          {variation >= 0 ? <ArrowTrendingUpIcon className="h-3 w-3" /> : <ArrowTrendingDownIcon className="h-3 w-3" />}
        </div>
      )}
    </>
  )
}
